import { FormFieldConfig, FormFieldType } from '@mri/types';

export const propertyCommonField: FormFieldConfig = {
  key: 'propertyId',
  label: 'Propietario',
  type: FormFieldType.OPTIONS,
  containerClass: 'col-12',
  optionsGateway: 'properties',
  hide: ({ auth }) => (auth?.propertyIds?.length || 0 ) < 2
}
